import { render, staticRenderFns } from "./GameScreen.vue?vue&type=template&id=3890d35f&"
import script from "./GameScreen.vue?vue&type=script&lang=ts&"
export * from "./GameScreen.vue?vue&type=script&lang=ts&"
import style0 from "./GameScreen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports